var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=logger2.js.map
